export const buildProductBadge = (product) => {
  let html = '';
  const hasComparePrice = product.compare_at_price_min > product.price_min;

  // Sale price takes precedence
  if (hasComparePrice) {
    return `
      <span class="prod-card__banner-badge prod-card__banner-badge--sale">Sale</span>
      <span class="prod-card__banner-background prod-card__banner-background--sale"></span>
    `;
  }

  // Check for badge tags
  const badgeTag = product.tags.find((tag) => tag.startsWith('badge:'));
  if (badgeTag) {
    const badgeType = badgeTag
      .split('badge:')[1]
      .toLowerCase()
      .replace(' ', '-');
    let badgeLabel = '';

    switch (badgeType) {
      case 'sale':
        badgeLabel = 'Sale';
        break;
      case 'best-seller':
        badgeLabel = 'Best Seller';
        break;
      case 'new':
        badgeLabel = 'New';
        break;
      case 'multi-buy':
        badgeLabel = 'Multi-Buy';
        break;
    }

    if (badgeLabel) {
      html = `
        <span class="prod-card__banner-badge prod-card__banner-badge--${badgeType}">${badgeLabel}</span>
        <span class="prod-card__banner-background prod-card__banner-background--${badgeType}"></span>
      `;
    }
  }

  return html;
};
